import {
  Plugin,
  FileRepository,
  FileLoader,
  UploadAdapter,
  UploadResponse,
} from "ckeditor5";

export type FileUploadApi = {
  uploadFile: UploadFileFunction;
};

export type UploadFileFunction = (file: File) => Promise<{ url: string }>;

export default class UploadWithContext extends Plugin {
  public static get requires() {
    return [FileRepository];
  }

  public init() {
    const api = this.editor.config.get("fileUploadApi");
    if (api == null) return;

    this.editor.plugins.get(FileRepository).createUploadAdapter = (loader) =>
      new UploadWithContextAdapter(loader, api.uploadFile);
  }
}

export class UploadWithContextAdapter implements UploadAdapter {
  private loader: FileLoader;
  private uploadFile: UploadFileFunction;

  constructor(loader: FileLoader, uploadFile: UploadFileFunction) {
    this.loader = loader;
    this.uploadFile = uploadFile;
  }

  async upload(): Promise<UploadResponse> {
    const file = await this.loader.file;
    if (file == null) {
      //
      // CKE documentation implies this is not possible
      // but TypeScript says that it is
      //
      throw new Error("File not returned from loader");
    }

    const result = await this.uploadFile(file);

    return {
      default: result.url,
    };
  }
}

declare module "ckeditor5" {
  interface EditorConfig {
    fileUploadApi?: FileUploadApi;
  }
}
